// extracted by mini-css-extract-plugin
export var wordContainer = "_kx-0";